<template>
  <div class="form-group">
    <div class="mar-lt-20">
      <label class="pad-bt-5">{{$t('upload.uploadLabel')}}</label>
      <el-upload
        action=""
        :file-list="fileList"
        :on-change="handleChange"
        :on-remove="handleRemove"
        :on-exceed="handleExceed"
        :limit="1"
        :auto-upload="false"
        accept='.pdf'
        ref=upload>
        <el-button size="small" type="primary">{{$t('upload.browse')}}</el-button>
        <div class="el-upload__tip" slot="tip">{{$t('validations.pdfSize')}}</div>
        <span class="el-upload-list__item-actions"></span>
      </el-upload> 
    </div>
    <template v-if="location.qr_code">
      <div class="col-md-12 px-0">
        <img v-bind:src="location.qr_code">
      </div>
      <div class="col-md-12 mb-5 ml-4 px-0">
        <a class="btn btn-info btn-icon duplicate-prod" :href="this.apiUrl + '/settings/download?token=' + this.$session.get('token') + '&url=' + this.location.qr_code + '&name=' + location.city + ' ' + location.name + '.png'" target="_blank">{{$t('upload.download')}}</a>
      </div>
      <div class="row" v-if="location.qr_code">
        <div class="col-md-11 col-sm-5">
          <input
            class="form-control"
            ref="clone"
            v-on:focus="$event.target.select()"
            :value="location.qr_code_url"
            readonly />
        </div>
        <div class="col-md-1 col-sm-1">
          <button class="btn btn-info btn-icon duplicate-prod mar-to-3" @click.prevent="copy"><i class="fa fa-copy"/></button>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
  import swal from 'sweetalert2'

  export default {
    name: 'file-input',
    inheritAttrs: false,
    props: {
      location: Object,
      type: String
    },
    data () {
      return {
        apiUrl: ''
      }
    },
    computed: {
      fileList () {
        if (!this.location || !this.location.qr_code) return []
        return [{ name: 'menu', url: this.location.qr_code }]
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
    },
    methods: {
      beforeUpload (file) {
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            title: self.$t('validations.pdfSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
        }
        return isOkSize
      },
      handleChange (file, fileList) {
        const isOkSize = file.size / 1024 / 1024 < 25
        const isPdf = file.raw.type === 'application/pdf'
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('validations.pdfSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
          this.$refs.upload.clearFiles()
        } else if (!isPdf) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('validations.wrongFormat'),
            position: 'top-end',
            showConfirmButton: true,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
          this.$refs.upload.clearFiles()
        } else {
          self.getBase64(file.raw).then(
            (base64enc) => {
              self.$bus.$emit('upload', {id: this.location.id, file: base64enc})
            }
          )
        }
      },
      handleRemove (file, fileList) {
        this.$bus.$emit('remove-upload', {id: this.location.id})
      },
      handleExceed (files, fileList) {
        var self = this
        swal({
          toast: true,
          text: self.$t('validations.removePhoto'),
          type: 'warning',
          position: 'top-end',
          showConfirmButton: true
        })
      },
      copy () {
        this.$refs.clone.focus()
        document.execCommand('copy')
      }
    }
  }
</script>

<style>
  p {
    overflow: hidden;
  }
  .mb-5 {
    margin-bottom: 2rem;
  }
  .ml-4 {
    margin-left: 1.25rem;
  }
  .px-0 {
    padding-left: 0;
    padding-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Inputs/FileInput.vue